import {Box, Typography} from "@mui/material";
import moment from "moment";
import {extensionLabel} from "../../../../project/campaigns/hooks/useAmiExtensions";

const SummaryItem = ({label, value}) => (
  <Box sx={{minWidth: 0}}>
    <Typography sx={{fontSize: 10, fontWeight: 600, letterSpacing: "0.08em", color: "#8A8AA0", textTransform: "uppercase"}}>{label}</Typography>
    <Typography noWrap sx={{fontSize: 13, fontWeight: 600, color: "#23264D", mt: 0.25}}>{value || "-"}</Typography>
  </Box>
);

export const CampaignSummaryNew = ({campaign, extension}) => {
  return (
    <Box sx={{
      bgcolor: "#FAFAFD", p: 2, borderRadius: "16px", width: "100%",
      display: "grid", gap: 2, gridTemplateColumns: {xs: "repeat(2, 1fr)", md: "repeat(4, 1fr)", lg: "repeat(8, 1fr)"},
    }}>
      <SummaryItem label="From number" value={campaign.fromNumber}/>
      <SummaryItem label="Extension" value={extensionLabel(extension) || (campaign.extensionId ? "Unknown" : "-")}/>
      <SummaryItem label="Trunk" value={extension ? extension.trunk || "Default" : "-"}/>
      <SummaryItem label="Dates" value={`${moment(campaign.startDate).format("DD MMM")} – ${moment(campaign.endDate).format("DD MMM YYYY")}`}/>
      <SummaryItem label="Calling window" value={`${campaign.startTime} – ${campaign.endTime}`}/>
      <SummaryItem label="Max attempts" value={String(campaign.maxAttempts ?? "-")}/>
      <SummaryItem label="Phone numbers" value={String(campaign.totalPhoneNumbers ?? 0)}/>
      <SummaryItem label="Created" value={campaign.dateCreated ? moment(campaign.dateCreated).format("DD MMM YYYY HH:mm") : "-"}/>
    </Box>
  )
}
